import { Form, Skeleton, Button, Row, Col, Radio, Card, ConfigProvider } from 'antd';
import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import handleRsponse from '../../helper/handleRsponse';
import TechnicianRepo from '../../repository/technicianRepository';
import logo from '../../App/logo.png'
const TechnicainInfo = (props) => {
    const [isLoaded, setIsLoaded] = useState(true);
    const [img, setImg] = useState();
    const [techInfo, setTechInfo] = useState({ firstName: '', lastName: '', mobile: '', techCode: '', city: '', agentname: '', agentCode: '' });
    useEffect(() => {
        let unId = (queryString.parse(props.location.search).unId);
        if (unId !== undefined) {
            handleRsponse.handleAxios(TechnicianRepo.getTechnicianInfo(`techId=${unId}`), fillTechInfo, setIsLoaded);
            TechnicianRepo.getTechnicianImage(`techId=${unId}`).then(res => setImg(res));
        }

    }, []);
    const fillTechInfo = (response) => {
        console.log(handleRsponse.getResponse(response), 'testttt');
        setTechInfo(handleRsponse.getResponse(response));
    }
    return (
        <ConfigProvider direction="rtl">

            <div style={{ padding: 20 }}>
                <Skeleton
                    show={!isLoaded}
                    loading={!isLoaded}
                    active
                    paragraph={{
                        rows: 4,
                    }}
                    size='small'
                >
                    <Card>
                        <Row>
                            <Col xs={24} sm={6} md={6} lg={12} xl={6}>
                                <img src={img} alt="icons" className='techImage' />
                            </Col>
                            <Col xs={24} sm={18} md={18} lg={18} xl={18}>
                                <Row >
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>نام:</b><span>{techInfo.firstName + ' ' + techInfo.lastName}</span>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>کد:</b><span>{techInfo.techCode}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>شماه تماس:</b><span>{techInfo.mobile}</span>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>محدوده فعالیت:</b><span>{techInfo.city}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>کد نماینده:</b><span>{techInfo.agentCode}</span>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                        <b>نام نماینده:</b><span>{techInfo.agentname}</span>
                                    </Col>
                                </Row>
                            </Col>

                        </Row>

                    </Card>
                </Skeleton>

            </div>


        </ConfigProvider>
    )
}
const mapStateToProps = state => ({});
const mapActionCreateor = {

}
export default connect(mapStateToProps, mapActionCreateor)(TechnicainInfo)